import React from 'react'
import { connect } from 'react-redux'
import { hideNotification } from '../actions/notificationsActions'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  notifications: string[]
  hideNotification: Callback
}

export const NotificationsView = ({ notifications, hideNotification }) => (
  <ul className="notifications list__reset">
    <TransitionGroup className="notification-list">
      {notifications.map((notification, index) => (
        <CSSTransition
          key={index}
          classNames="notification"
          timeout={{
            enter: 500,
            exit: 300,
          }}
        >
          <li className={`notifications__${notification.className}`}>
            {notification.message}
            <span
              className="notifications__close"
              onClick={() => hideNotification(notification.message)}
            >
              x
            </span>
          </li>
        </CSSTransition>
      ))}
    </TransitionGroup>
  </ul>
)

NotificationsView.displayName = 'NotificationsView'

export const mapStateToProps = (state) => ({
  notifications: state.notifications,
})

export const mapDispatchToProps = (dispatch) => ({
  hideNotification: (message) => dispatch(hideNotification(message)),
})

export const Notifications = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsView)
